<template>
  <div>
    <h2>Dashboard</h2>
    <v-breadcrumbs :items="items">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-row>
      <v-col sm="12">
        <v-card class="stat-card">
          <v-card-text>
            <p class="mb-5 text-h6">You haven't any tours yet!</p>
            <v-btn class="sh-green" color="primary" small>Create tour now</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col sm="4">
        <v-card class="stat-card">
          <v-card-text>
            Total Tours
            <div class="text-h4 stat-card__counter">18,765</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="4">
        <v-card class="stat-card">
          <v-card-text>
            Total Views
            <div class="text-h4 stat-card__counter">18,765</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="4">
        <v-card class="stat-card stat-card--pro">
          <v-card-text>
            Used data
            <div class="text-h4 stat-card__counter">18 MB</div>
            <v-btn class="sh-green stat-card--pro-btn" color="primary" small>Get PRO (βeta)</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Dashboard',
  data: () => ({
    items: [
      {
        text: 'Dashboard',
        disabled: false,
        href: 'dashboard'
      },
      {
        text: 'Statistic',
        disabled: true
      }
    ]
  })
}
</script>

<style lang="scss" scoped>
.stat-card {
  box-shadow: 0 12px 50px 2px #13507c24 !important;

  &__counter {
    font-weight: 600;
  }

  &--pro {
    background: linear-gradient(250.16deg, #ffffff 2.51%, rgba(213, 241, 255, .54) 96.8%);
  }

  &--pro-btn {
    position: absolute;
    top: 12px;
    right: 12px;
  }
}
</style>
